import { AnyAction } from '@reduxjs/toolkit';
import { SET_ADMIN_USER } from '../action-types';
import { CreateCustomerRoutine } from '~modules/Companies/redux-routines';
import type { ISetAdminUserAction } from '../actions';
import type { IAdminUserRegistrationState } from '../interfaces';

export const initialState: IAdminUserRegistrationState = {
  data: {},
};

export const adminUserRegistrationReducer = (
  state: IAdminUserRegistrationState = initialState,
  action: AnyAction,
): IAdminUserRegistrationState => {
  switch (action.type) {
    case SET_ADMIN_USER:
      return {
        ...state,
        data: { ...state.data, ...(action as ISetAdminUserAction).payload },
      };
    case CreateCustomerRoutine.SUCCESS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
